(function () {
  'use strict';

  angular.module('app').component('invoiceDetail', invoiceDetail());

  function invoiceDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<',
        // fromBooking: '<',
        bookingData: '<',
        onInvoiceSaved: '&',
        onInvoiceCanceled: '&',
      },
      controller: InvoiceDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/invoices/invoice-detail/invoice-detail.component.html',
    };
  }

  InvoiceDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AbilityService',
    'moment',
    'InvoiceService',
    'ClientService',
    'TaxService',
    'DocumentTypeService',
    'MeasurementUnitService',
    'ProductService',
    'ExchangeRateService',
    'ModalWindowConfirmService',
    'DocumentService',

    // Angular downgraded service
    'companyService',
    'currencyService',
    'ReceivedPaymentService',
  ];

  function InvoiceDetailComponent(
    config,
    UtilService,
    SessionService,
    AbilityService,
    moment,
    InvoiceService,
    ClientService,
    TaxService,
    DocumentTypeService,
    MeasurementUnitService,
    ProductService,
    ExchangeRateService,
    ModalWindowConfirmService,
    DocumentService,

    // Angular downgraded service
    companyService,
    currencyService,
    ReceivedPaymentService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_invoice_accountadmin'),
      canUpdate: AbilityService.can('update_invoice_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.statusDraft = 'draft';
    vm.statusPaid = 'paid';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    vm.creditsInFavor = [];

    // private properties
    // -----------------------
    let company = SessionService.getSelectedAccountCompany();
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      vm.invalidClientForDocumentType = false;

      if (vm.item.id) {
        // view - edit
        if (!vm.item.user_id) vm.item.user_id = SessionService.currentUser().id;

        vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';

        setItemOptions(vm.item, vm.mode);

        // console.log(vm.item);

        // validateItemActions();

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
        getCreditsInFavor();
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          // type: '01', // electronic invoice TODO: What about other countries
          // date: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }), // error with hacienda as 2020-11-03 06:00:00.000Z
          date: moment(),
          due_date: '',
          unit_price_type: true,
          subtotal_services_taxable: 0,
          subtotal_services_exempt: 0,
          subtotal_services_exonerable: 0,
          subtotal_goods_taxable: 0,
          subtotal_goods_exempt: 0,
          subtotal_goods_exonerable: 0,
          total_taxable: 0,
          total_exempt: 0,
          total_exonerable: 0,
          total_sale: 0,
          total_discount: 0,
          total_net_sale: 0,
          total_taxes: 0,
          total_exonerations: 0,
          total_net_taxes: 0,
          grand_total: 0,
          invoice_products: [],
          bookings: [],
          booking_ids: [],
          company_id: company.id,
          user_id: SessionService.currentUser().id,
          // client: '',

          // payment_method_code: null,
          // payment_method_codes: [],
        };

        vm.sendInvoiceToClient = false;

        // Initializers
        getDocumentTypes();

        vm.documentDate = moment();

        // adding all object information from booking
        if (vm.bookingData) {
          vm.item.unit_price_type = vm.bookingData.unit_price_type;
          vm.item.client_email_receipt = vm.bookingData.client_email_receipt;
          vm.item.is_from_booking = vm.bookingData.is_from_booking;
          vm.item.booking_ids = vm.bookingData.booking_ids;
          vm.item.bookings = vm.bookingData.bookings;
          vm.item.sale_channel_id = vm.bookingData.sale_channel_id;
          vm.item.sale_source_id = vm.bookingData.sale_source_id;
          vm.item.sale_condition_code = vm.bookingData.sale_condition_code;
          vm.item.payment_method_code = vm.bookingData.payment_method_code;
          vm.item.payment_method_id = vm.bookingData.payment_method_id;
          vm.item.currency_id = vm.bookingData.currency_id;
          vm.item.client_id = vm.bookingData.client.id;
          vm.item.client = vm.bookingData.client;
          vm.item.notes = transformNotes(vm.bookingData);
          vm.item.invoice_products = vm.bookingData.invoice_products;

          // vm.item.payment_method_code  = vm.bookingData.payment_method_code;
          // vm.item.payment_method_codes = vm.bookingData.payment_method_codes;
        } else {
          vm.addInvoiceProduct();
        }
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    // Atv functions
    vm.sendDocumentToAtv = function (item) {
      vm.loadingDocument = true;
      DocumentService.sendDocumentToAtv(vm.item, 'invoices').then((data) => {
        if (data) {
          vm.item.atv_status = data.atv_status;
          // validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.resendDocumentToAtv = function () {
      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(vm.item, 'invoices').then((data) => {
        if (data) {
          vm.item.atv_status = data.atv_status || vm.item.atv_status; // Important if no atv status sent
          // validateItemActions();
        }

        vm.loadingDocument = false;
      });
    };

    vm.downloadInvoicePdf = function () {
      InvoiceService.downloadInvoicePdf(vm.item, userLanguageCode);
    };

    vm.printElectronicTicketPdf = function () {
      InvoiceService.printElectronicTicketPdf(
        vm.item.id,
        vm.item.company_id,
        userLanguageCode
      ).then(function (response) {
        let blobVar = new Blob([response.data], { type: 'application/pdf' });

        let dataUrl = window.URL.createObjectURL(blobVar);
        let pdfPreview = document.createElement('iframe');

        pdfPreview.width = '0';
        pdfPreview.height = '0';
        pdfPreview.src = dataUrl;

        document.body.appendChild(pdfPreview);
        pdfPreview.focus();

        setTimeout(() => {
          pdfPreview.contentWindow.print();
        }, 200);
      });
    };

    vm.notifyDocumentToClient = function () {
      if (
        vm.item.status !== vm.statusPaid ||
        (vm.atvCrEnabled && vm.item.atv_status !== vm.statusAccepted)
      )
        return;

      const successCallBack = function (email) {
        vm.item.client_email_receipt = email;

        vm.loadingDocument = true;
        DocumentService.notifyDocumentToClient(vm.item, 'invoices', email).then(() => {
          vm.loadingDocument = false;
        });
      };

      DocumentService.openNotifyDocumentToClient(
        vm.item.client.email,
        successCallBack,
        'SEND_INVOICE_TO_CLIENT'
      );
    };

    vm.openRelatedTransactions = function () {
      InvoiceService.openRelatedTransactions(vm.item, vm.item.client);
    };

    vm.applyAmountInExcess = function (creditInFavor) {
      let receivedPayment = {
        client_id: vm.item.client.id,
        currency_id: vm.item.currency_id,
        user_id: vm.item.user_id,
        amount: creditInFavor.received_payment.amount_in_excess,
        received_payment_id: creditInFavor.received_payment.id,
        document_type_id: vm.item.document_type_id,
        company_id: vm.item.company_id,
        payment_method_code: vm.item.payment_method_code,

        received_payment_documents: [
          {
            document_date: creditInFavor.incoming_prepayment.due_date,
            document_id: vm.item.id,
            payment_date: vm.UtilService.startOfDayFormat(new Date()),
            total_price: vm.item.balance_due,
            newBalance: vm.item.balance_due - creditInFavor.received_payment.amount_in_excess,
            balance: vm.item.balance_due,
            amount: creditInFavor.received_payment.amount_in_excess,
            type: 'invoice',
          },
        ],
      };

      let applyCreditInFavor = function () {
        ReceivedPaymentService.saveReceivedPayment(receivedPayment).then(function (data) {
          let status = data.status;
          let response = data.response;
          if (status) {
            creditInFavor.received_payment = response;
            vm.item.balance_due = receivedPayment.received_payment_documents[0].newBalance;
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }
        });
      };

      let params = {
        mode: 'warning',
        title: 'APLY_CREDIT_IN_FAVOR',
        body: 'APLY_CREDIT_IN_FAVOR_NOTE',
      };

      ModalWindowConfirmService.open(params, applyCreditInFavor);
    };

    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      if (
        vm.sendingForm ||
        !(
          vm.item.client_id &&
          vm.item.currency_id &&
          vm.item.sale_condition_code &&
          vm.item.sale_channel_id &&
          vm.item.sale_source_id &&
          vm.item.document_type_id &&
          vm.item.user_id &&
          vm.item.date
        ) ||
        // (!vm.item.is_guest && !vm.item.client_id) ||
        (vm.saleCondition &&
          vm.saleCondition.value === 'credit' &&
          vm.item.credit_payment_days === undefined) ||
        (vm.saleCondition &&
          vm.saleCondition.value === 'cash' &&
          vm.item.status !== vm.statusDraft &&
          !vm.receivedPayment.payment_method_code) ||
        (vm.createMode &&
          vm.documentType &&
          vm.documentType.numbering_type === 'manual' &&
          !vm.item.invoice_number)
      ) {
        return true;
      }

      // !vm.item.payment_method_code

      return false;
    };

    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      /*if (vm.documentType.client_required) {
                vm.item.is_guest = false;

                vm.item.guest_name = null;
            }*/

      if (vm.documentType.type) {
        vm.item.type = vm.documentType.type;
      }

      validateClientForDocumentType();

      setPaymentDatePicker(vm.documentType);
    };

    vm.onClientSelected = function (client) {
      /*if (!ClientService.checkAddress(client)){ // TODO: campbell, ok you are showing the warning. but how the usar can update the info without leaving the current page ?
                vm.item.client = null;
                return;
            }*/

      let selectClientCallback = function () {
        vm.lastClientId = client.id;
        vm.item.client_id = client.id;
        vm.item.client = client;

        vm.item.currency_id = client.currency_id ? client.currency_id : vm.companyBaseCurrencyId;
        let currency = vm.currenciesPerCompany.find((item) => item.id === vm.item.currency_id); // client.currency_id

        vm.selectCurrency(currency, true);

        vm.item.sale_condition_code = null;

        vm.item.credit_payment_days = null;
        vm.item.due_date = null;

        let clientSaleCondition;

        if (client.credit_enabled) {
          // Client has credit enabled
          vm.clientSaleConditions = vm.company.sale_conditions;
          clientSaleCondition = vm.clientSaleConditions.find((item) => item.value === 'credit');
        } else {
          let saleConditions = angular.copy(vm.company.sale_conditions);
          vm.clientSaleConditions = vm.UtilService.removeItemFromArray(
            saleConditions,
            'value',
            'credit'
          );
          clientSaleCondition = vm.clientSaleConditions.find((item) => item.value === 'cash');
        }

        validateClientForDocumentType();

        vm.item.sale_condition_code = clientSaleCondition.code;

        vm.item.bookings = [];

        vm.selectSaleCondition(clientSaleCondition);
      };

      // Delete invoice products for draft invoice if change client, when the invoice has products
      if (
        vm.item.status === vm.statusDraft &&
        vm.item.invoice_products.length > 0 &&
        vm.lastClientId &&
        client.id !== vm.lastClientId
      ) {
        let successCallback = function () {
          vm.item.invoice_products = [];

          selectClientCallback();

          return;
        };

        let cancelCallback = function () {
          // Just to keep current client
          vm.item.client_id = vm.lastClientId;
        };

        let modalParams = {
          title: 'CHANGE_CLIENT_FOR_CURRENT_INVOICE',
          body: 'CHANGE_CLIENT_FOR_CURRENT_INVOICE_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        // In case the user change the client
        if (vm.lastClientId && client.id !== vm.lastClientI) {
          vm.item.invoice_products = [];
          vm.addInvoiceProduct();
        }

        selectClientCallback();
      }
    };

    // When client is empty
    vm.onClientValidated = function (client) {
      vm.item.client = client;

      if (!vm.item.client && vm.item.client_id) {
        resetClientInput();
      }
    };

    vm.onClientCleared = function (clearObj) {
      if (clearObj) {
        vm.item.client = null;
      }

      resetClientInput();
    };

    vm.selectActivityCode = function (activityCode) {
      if (vm.activityCode && vm.activityCode.code === activityCode.code) return;

      vm.activityCode = activityCode;
    };

    vm.selectCurrency = function (currency, setCurrency) {
      if (currency.id === vm.lastCurrencyId && !setCurrency) return;

      vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);
      // console.log(vm.documentDateExchangeRate);
      // {value: 1, conversion: 'multiply', exchangeRateValue: 1}

      vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;
      vm.item.base_currency_symbol = vm.currenciesPerCompany.find(
        (x) => x.id === vm.companyBaseCurrencyId
      ).symbol;

      let selectCurrenyCallback = () => {
        vm.item.currency = currency;
        vm.lastCurrencyId = currency.id;
        vm.lastCurrency = currency;
      };

      if (setCurrency) {
        selectCurrenyCallback();
        return;
      }

      if (!vm.viewMode) {
        if (vm.item.invoice_products.length > 0) {
          if (vm.editMode) {
            vm.lastCurrencyId = vm.item.currency.id;
          }

          // console.log(currency.id);
          // console.log(vm.lastCurrencyId);

          convertInvoiceProductsPrices(currency, vm.lastCurrencyId); // TODO: check if needed ????? - edit only ?
        }

        selectCurrenyCallback();
      }
    };

    vm.setTodayExchangeRate = function () {
      vm.settingTodayExchangeRate = true;

      currencyService
        .setAutomaticExchangeRate(vm.item.currency, vm.companyTimeZoneUtc)
        .subscribe((response) => {
          if (response) {
            vm.documentDateExchangeRate.value = response.lastExchangeRate.rate;
            vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;

            // Cannot read properties of undefined (reading 'rate')
          }

          vm.settingTodayExchangeRate = false;
        });
    };

    vm.selectSaleCondition = function (saleCondition) {
      // Same open condition selected
      if (vm.saleCondition && vm.saleCondition.id === saleCondition.id) return;

      vm.saleCondition = saleCondition;
      vm.item.due_date = vm.item.date;
      vm.item.credit_payment_days = null;

      vm.receivedPayment = {
        payment_method_code: null,
        payment_method_id: null,
      };

      if (saleCondition.value === 'credit') {
        let creditPaymentTerm = vm.company.credit_payment_terms.find((item) => {
          return item.id === vm.item.client.default_credit_payment_term_id;
        });

        if (creditPaymentTerm) {
          vm.item.credit_payment_days = creditPaymentTerm.days;

          vm.selectCreditPaymentTerm(creditPaymentTerm.days);
        }

        // vm.item.payment_method_code = '01'; // required
        vm.receivedPayment.payment_method_code = '01'; // required for atv ?
      }
    };

    vm.selectPaymentMethod = function (paymentMethod) {
      vm.receivedPayment.paymentMethod = paymentMethod;

      vm.receivedPayment.payment_method_id = paymentMethod.id;
    };

    vm.selectCreditPaymentTerm = function (creditPaymentTermDays) {
      let dueDate = angular.copy(vm.item.date); // Important
      vm.item.due_date = moment(dueDate).add(creditPaymentTermDays, 'days');
    };

    vm.selectSaleChannel = function (saleChannel) {
      if (saleChannel.is_website) {
        vm.item.website_id = saleChannel.website_id;
        return;
      }

      delete vm.item['website_id'];
    };

    // TODO: We can call the api with more info to avoid extra queries for invoice/client
    vm.openClientInfoModal = function (client) {
      ClientService.openClientInfoModal(client);
    };

    vm.openClientFastCreate = function () {
      let successCallBack = function (client) {
        vm.onClientSelected(client);
      };

      ClientService.openClientFastCreate({}, successCallBack);
    };

    vm.onPriceTypeChanged = function () {
      vm.item.invoice_products.forEach(function (invoiceProduct) {
        vm.calculateInvoiceProductTotalPrice(invoiceProduct);
      });
    };

    vm.addInvoiceProduct = function () {
      vm.item.invoice_products.push({
        quantity: 1,
        // unit_price: 0,
        total_amount: 0,
        discount_percentage: 0,
        discount_amount: 0,
        subtotal_price: 0,

        tax_percentage: 0,
        tax_amount: 0,
        tax_exoneration_percentage: 0,
        tax_exoneration_amount: 0,
        net_tax_percentage: 0,
        net_tax_amount: 0,
        total_price: 0,
      });

      calculateInvoiceTotals();
    };

    vm.removeInvoiceProduct = function (index) {
      vm.item.invoice_products.splice(index, 1);
      // products = vm.item.invoice_products;

      calculateInvoiceTotals();

      // checkBookingsInUse();
    };

    vm.searchProduct = function (invoiceProduct, value) {
      invoiceProduct.product_id = null;

      return ProductService.searchProducts({ value: value, skip_check_role: true }).then((data) => {
        if (data.length === 0) {
          resetProductFilter(invoiceProduct);
        }

        return data;
      });
    };

    // When product is empty
    vm.checkSearchProduct = function (invoiceProduct) {
      if (!invoiceProduct.product && invoiceProduct.product_id) {
        resetProductFilter(invoiceProduct);
      }
    };

    vm.selectProduct = function (invoiceProduct, product) {
      /*if (vm.atvCrEnabled) {
                invoiceProduct.type = '04'; // TODO: uso interno - WHY ?? make it dynamic  - is default in the api
            }*/

      // products.push(product);

      invoiceProduct.product_id = product.id;
      invoiceProduct.product_code = product.code;
      invoiceProduct.product_cabys_code = product.cabys_code;
      invoiceProduct.product_name = product.name;
      invoiceProduct.product_type = product.type;
      // invoiceProduct.tax_id             = null; TODO: what for?

      invoiceProduct.measurement_unit_id =
        product.measurement_unit_id || product.product_category.measurement_unit_id;
      invoiceProduct.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
        vm.company.measurement_units,
        invoiceProduct.product_type
      );

      let measurementUnit = invoiceProduct.measurement_units.find(
        (item) => item.id === invoiceProduct.measurement_unit_id
      );

      vm.selectMeasurementUnit(invoiceProduct, measurementUnit);

      getTaxesPerProduct(invoiceProduct, product);

      vm.calculateInvoiceProductTotalPrice(invoiceProduct);
    };

    vm.selectMeasurementUnit = function (invoiceProduct, measurementUnit) {
      if (!measurementUnit) return;

      invoiceProduct.measurement_unit = measurementUnit;
      invoiceProduct.measurement_unit_symbol = measurementUnit.symbol;
    };

    vm.editInvoiceProductRemarks = function (invoiceProduct) {
      vm.invoiceProduct = invoiceProduct;
    };

    vm.calculateInvoiceProductTotalPrice = function (invoiceProduct) {
      invoiceProduct.quantity = invoiceProduct.quantity || 1;

      invoiceProduct.tax_percentage = TaxService.getProductTaxesTotalPercentage(
        invoiceProduct.productTaxes
      );
      invoiceProduct.tax_exoneration_percentage =
        TaxService.getProductTaxesTotalExonerationPercentage(invoiceProduct.productTaxes);
      invoiceProduct.net_tax_percentage =
        invoiceProduct.tax_percentage - invoiceProduct.tax_exoneration_percentage;

      let unitPrice = 0; // '' 0
      let discountPercentage = 0;

      if (vm.item.unit_price_type) {
        unitPrice = invoiceProduct.unit_price; //  || 0
        discountPercentage = invoiceProduct.discount_percentage || 0;
      } else {
        invoiceProduct.total_price = invoiceProduct.total_price || 0;

        //  Unit price is calculated as Total divided by quantity before taxes
        let basePrice = invoiceProduct.total_price / (invoiceProduct.tax_percentage / 100 + 1);

        // TODO. exonerations ??

        unitPrice = basePrice / invoiceProduct.quantity;
      }

      let totalAmount = invoiceProduct.quantity * unitPrice;
      let discountAmount = totalAmount * (discountPercentage / 100);
      let subtotalPrice = totalAmount - discountAmount;

      invoiceProduct.transaction_taxes = TaxService.setProductTaxesAmounts(
        subtotalPrice,
        invoiceProduct.productTaxes
      );

      let taxAmount = TaxService.getProductTaxesTotalAmount(invoiceProduct.transaction_taxes);
      let taxExonerationAmount = TaxService.getProductTaxesTotalExonerationAmount(
        invoiceProduct.transaction_taxes
      );
      let netTaxAmount = taxAmount - taxExonerationAmount;

      if (unitPrice) {
        invoiceProduct.unit_price = vm.UtilService.roundNum(unitPrice);
      }

      invoiceProduct.total_amount = vm.UtilService.roundNum(totalAmount);
      invoiceProduct.discount_percentage = discountPercentage;
      invoiceProduct.discount_amount = vm.UtilService.roundNum(discountAmount);
      invoiceProduct.subtotal_price = vm.UtilService.roundNum(subtotalPrice);

      invoiceProduct.tax_amount = vm.UtilService.roundNum(taxAmount);
      invoiceProduct.tax_exoneration_amount = vm.UtilService.roundNum(taxExonerationAmount);
      invoiceProduct.net_tax_amount = vm.UtilService.roundNum(netTaxAmount);

      if (vm.item.unit_price_type) {
        invoiceProduct.total_price = vm.UtilService.roundNum(subtotalPrice + netTaxAmount); // taxAmount
      }

      calculateInvoiceTotals();

      // invoiceProduct.tax_percentage = invoiceProduct.transaction_taxes ? invoiceProduct.transaction_taxes.reduce(
      //     (total, tax) => total + tax.value, 0
      // ) : 0;

      // let taxAmount      = TaxService.setProductTotalTaxAmount(invoiceProduct.transaction_taxes, subtotalPrice);
      // let taxExonerationAmount = invoiceProduct.transaction_taxes.reduce((total, tax) => total + tax.exoneration.amount, 0);
    };

    vm.openDocumentProductTaxesExonerations = function (invoiceProduct) {
      if (vm.viewMode || invoiceProduct.tax_amount === 0) return;

      const successCallBack = function (documentProductObj) {
        // console.log(documentProductObj);
        vm.calculateInvoiceProductTotalPrice(documentProductObj); // invoiceProduct
      };

      ProductService.openDocumentProductTaxesExonerations(
        invoiceProduct,
        vm.item.currency,
        'sales',
        successCallBack
      );
    };

    vm.editInvoice = function () {
      const successCallback = (data) => {
        hideWarningMessageModal(data);

        vm.editMode = true;
        vm.viewMode = false;

        // here ??
        vm.originalItem = angular.copy(vm.item); // store server data
        // vm.originalItemProducts = angular.copy(vm.item.invoice_products);

        // products = vm.originalItem.invoice_products;

        getDocumentTypes();

        if (vm.companyCurrencyIds) {
          getCurrencies(vm.companyCurrencyIds);
        }
      };

      const cancelCallback = (data) => {
        hideWarningMessageModal(data);
        vm.editMode = false;
        vm.viewMode = true;
      };

      const showRelatedTransactionsCallback = (data) => {
        hideWarningMessageModal(data);
        vm.openRelatedTransactions();
      };

      InvoiceService.hasRelatedTransactions(vm.item.id, vm.item.client.id).then((data) => {
        if (data && !SessionService.isWarningMessageHidden('invoices')) {
          let modalParams = {
            mode: 'warning',
            title: 'RECORD_WITH_RELATED_TRANSACTION',
            relatedTransactionButtonLabel: 'VIEW_RELATED_TRANSACTIONS',
            confirmButtonLabel: 'YES',
            cancelButtonLabel: 'NO',
            body: '',
          };

          ModalWindowConfirmService.open(
            modalParams,
            successCallback,
            cancelCallback,
            showRelatedTransactionsCallback
          );
        } else {
          successCallback;
        }
      });
    };

    /*vm.cancelEdit = function() {
            vm.item = vm.originalItem;
            // vm.item.invoice_products = vm.originalItemProducts;

            setItemOptions(vm.item);
            setInvoiceProducts();
        };*/

    vm.saveInvoice = function (isFormValid, status) {
      vm.formErrors = false;

      if ((!isFormValid || vm.invalidClientForDocumentType) && status !== vm.statusDraft) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      if (!vm.allProductsCabysCodeSet) return;

      if (bookingsInUsed()) {
        const successCallBack = function () {
          saveInvoiceContinue(status);
        };

        InvoiceService.openInvoiceBookingInUsedAlert(successCallBack);
      } else {
        saveInvoiceContinue(status);
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onInvoiceCanceled();
    };

    /*vm.selectIsGuest = function() {
            vm.item.guest_name = vm.item.client || null;

            vm.item.client_id = null;
            vm.item.client    = null;

            vm.item.sale_condition_code = null;
            vm.saleCondition = null;

            if (vm.item.is_guest) {
                setTimeout(() => { // hack
                    document.querySelector('input[name="guest_name"]').focus();
                }, 100);

                vm.item.currency_id = vm.companyBaseCurrencyId;
                let currency        = vm.currenciesPerCompany.find((item) => item.id === vm.item.currency_id);

                vm.selectCurrency(currency, true);

                let saleConditions      = angular.copy(vm.company.sale_conditions);
                vm.clientSaleConditions = vm.UtilService.removeItemFromArray(saleConditions, 'value', 'credit');
                let clientSaleCondition = vm.clientSaleConditions.find((item) => item.value === 'cash');

                vm.item.sale_condition_code = clientSaleCondition.code;

                vm.selectSaleCondition(clientSaleCondition);
            }
        };*/

    vm.openAddBookingToInvoice = function () {
      let successCallback = function (booking) {
        /*let bookingFound = false;

                for (let i = 0; i < vm.item.bookings.length; i++) {
                    if (vm.item.bookings[i].id === booking.id) {
                        bookingFound = true;
                        break;
                    }
                }*/

        let bookingFound = vm.item.bookings.find((bookingObj) => bookingObj.id === booking.id);

        if (!bookingFound) {
          vm.item.bookings.push(booking);
          vm.item.booking_ids.push(booking.id);
        }

        // vm.item.is_from_booking = true;
        vm.item.unit_price_type = true; // false;

        booking.booking_items.forEach(function (bookingItem) {
          bookingItem.currencyId = booking.currencyId;

          createInvoiceProductsFromBookingItem(bookingItem, booking);
        });
      };

      InvoiceService.openAddBookingToInvoice(vm.item, vm.item.client, successCallback);
    };

    // Remove all invoice products that belong to a booking
    vm.removeBookingFromInvoice = function (booking) {
      // This remove the item from array, based on the index
      let index = vm.item.booking_ids.indexOf(booking.id); // check with other bookings to see inconsistences

      vm.item.bookings.splice(index, 1);
      vm.item.booking_ids.splice(index, 1);
      // console.log(index);

      // This filter en create a new array
      // vm.item.bookings    = vm.item.bookings.filter((bookingObj) => bookingObj.id !== booking.id);
      // vm.item.booking_ids = vm.item.booking_ids.filter((id) => id !== booking.id);

      // needed ?
      if (vm.item.booking_ids.length === 0) {
        vm.item.is_from_booking = false;
        // vm.item.unit_price_type = true;
      }

      vm.item.invoice_products = vm.item.invoice_products.filter(
        (product) => product.booking_number !== booking.booking_number
      );

      calculateInvoiceTotals();
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editInvoice();
      }

      if (item.is_from_booking && item.invoice_products.length > 0 && item.bookings.length > 0) {
        setProductsFromBooking();
      }

      // if (item.received_payments.length > 0) {
      //   console.log(item.received_payments[0]);
      // vm.receivedPayment = item.received_payments[0]; // TODO: for now, what about rest payments
      // }

      // products = vm.item.invoice_products;
    }

    function setProductsFromBooking() {
      vm.item.invoice_products.forEach(function (product) {
        vm.item.bookings.forEach(function (booking) {
          booking.booking_items.forEach(function (bookingItem) {
            if (product.booking_item_id === bookingItem.id) {
              product.booking_number = booking.booking_number;
            }
          });
        });
      });
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = true;
      vm.loadingInvoiceProducts = true; // !important

      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;

          vm.company.payment_methods = vm.company.payment_methods.filter(
            (method) => method.status == true
          );

          setCompanySaleChannelsAndSaleSources(vm.company.sale_channels);

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;
          vm.companyTimeZoneUtc = vm.company.time_zone.utc;

          // Create / Edit
          if (!vm.viewMode) {
            getCurrencies(vm.companyCurrencyIds);
          }

          // View / Edit
          if (!vm.createMode) {
            setCompanyActivityCode(vm.company);

            vm.saleCondition = vm.company.sale_conditions.find(
              (x) => x.code === vm.item.sale_condition_code
            );

            vm.clientSaleConditions = vm.company.sale_conditions;

            // Client with credit disabled - viewMode
            if (vm.item.status === vm.statusDraft && !vm.item.client.credit_enabled) {
              let saleConditions = angular.copy(vm.clientSaleConditions);
              vm.clientSaleConditions = vm.UtilService.removeItemFromArray(
                saleConditions,
                'value',
                'credit'
              );
            }

            if (vm.item.credit_payment_days >= 0) {
              vm.creditPaymentTerm = vm.company.credit_payment_terms.find(
                (x) => x.days === vm.item.credit_payment_days
              );
            }

            // Cash
            if (vm.item.sale_condition_code === '01' && vm.receivedPayment) {
              vm.receivedPayment.paymentMethod = vm.company.payment_methods.find(
                (x) => x.code === vm.receivedPayment.payment_method_code
              );
            }

            if (vm.item.received_payments.length > 0) {
              const first_received_payment = vm.item.received_payments[0];
              let paymentMethod;

              // 99 = other
              if (first_received_payment.payment_method_code !== '99') {
                paymentMethod = vm.company.payment_methods.find(
                  (x) => x.code == first_received_payment.payment_method_code
                );
              } else {
                if (first_received_payment.payment_method_id) {
                  paymentMethod = vm.company.payment_methods.find(
                    (x) => x.id == first_received_payment.payment_method_id
                  );
                } else {
                  paymentMethod = vm.company.payment_methods.find(
                    (x) => x.code == first_received_payment.payment_method_code
                  );
                }
              }

              vm.receivedPayment = first_received_payment;
              vm.receivedPayment.paymentMethod = paymentMethod;
            }

            /*if (vm.item.payment_method_code){
                vm.paymentMethod = vm.company.payment_methods.find( (item) => item.code === vm.item.payment_method_code);
            }*/

            vm.user = vm.company.users.find((x) => x.id === vm.item.user_id);

            setInvoiceProducts();
          } else {
            vm.item.company_activity_code = vm.company.activity_codes.find(
              (x) => x.id === vm.company.company_activity_code_id
            ).code;

            vm.loadingInvoiceProducts = false; // !important

            if (vm.bookingData) {
              vm.clientSaleConditions = vm.company.sale_conditions;

              if (!vm.item.client.credit_enabled) {
                vm.clientSaleConditions = vm.clientSaleConditions.filter((x) => x.code !== '02');
              }

              let clientSaleCondition = vm.clientSaleConditions.find(
                (x) => x.code === vm.item.sale_condition_code
              );
              vm.selectSaleCondition(clientSaleCondition);

              let paymentMethod = vm.company.payment_methods.find(
                (x) => x.code === vm.item.payment_method_code
              );

              vm.receivedPayment = {
                paymentMethod: paymentMethod,
                payment_method_code: vm.item.payment_method_code,
                payment_method_id: vm.item.payment_method_id,
                reference_number: vm.bookingData.reference_number,
              };

              setInvoiceProducts();
              calculateInvoiceTotals();
            }
          }

          vm.loadingCompany = false;
        });
    }

    function setCompanyActivityCode(company) {
      if (!vm.atvCrEnabled) return;

      // let activityCode = company.activity_codes.find((activityCode) => activityCode.id === vm.item.company_activity_code_id);
      // let activityCode = company.activity_codes.find((activityCode) => activityCode.code === vm.item.company_activity_code);

      let activityCode = company.activity_codes.find((activityCode) => {
        return (
          activityCode.code === vm.item.company_activity_code ||
          activityCode.id === vm.item.company_activity_code_id
        );
      });

      vm.companyActivityCode = activityCode;
      vm.item.company_activity_code = activityCode.code;

      // TODO: why cambpell ?
      /*if (activityCode === undefined) {
                vm.companyActivityCode        = company.activity_codes.find((activity_code) => activity_code.id === company.company_activity_code_id);
                vm.item.company_activity_code = company.activity_codes.find((activity_code) => activity_code.id === company.company_activity_code_id).code;
            }
            else {
                vm.companyActivityCode = activityCode;
                vm.item.company_activity_code = activityCode.code;
            }*/
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'invoices',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then((data) => {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          vm.documentType = vm.documentTypes.find((documentType) => documentType.is_default); //  === true
          vm.item.document_type_id = vm.documentType.id;

          if (vm.documentType.type) {
            vm.item.type = vm.documentType.type;
          }

          if (vm.bookingData) {
            vm.selectDocumentType(vm.documentType);
            // vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';
          }
        } else {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.id === vm.item.document_type_id
          );
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';

        setPaymentDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function getCreditsInFavor() {
      vm.item.client.bookings.forEach((booking) => {
        booking.incoming_prepayments.forEach((incoming_prepayment) => {
          let received_payment_documents = incoming_prepayment.received_payment_documents;
          received_payment_documents.forEach((received_payment_document) => {
            let creditInFavor = {
              incoming_prepayment: { incoming_consecutive: 0, due_date: '' },
              received_payment: { date: '', amount_in_excess: 0.0 },
            };

            creditInFavor.incoming_prepayment.incoming_consecutive =
              incoming_prepayment.incoming_consecutive;
            creditInFavor.incoming_prepayment.due_date = incoming_prepayment.due_date;
            creditInFavor.received_payment.id = received_payment_document.received_payment.id;
            creditInFavor.received_payment.date = received_payment_document.received_payment.date;
            creditInFavor.received_payment.amount_in_excess =
              received_payment_document.received_payment.amount_in_excess;

            vm.creditsInFavor.push(creditInFavor);
          });
        });
      });
    }

    // TODO: dry
    function setCompanySaleChannelsAndSaleSources(saleChannels) {
      vm.saleChannels = [];
      vm.saleSources = [];

      if (!saleChannels) return;

      saleChannels.forEach(function (channel) {
        if (channel.status === 'active') {
          // Sale channels
          if (channel.is_channel) {
            vm.saleChannels.push(channel);

            if (vm.createMode && !vm.bookingData && channel.is_default_channel) {
              // Select default sale channel
              vm.item.sale_channel_id = channel.id;
            } else if (vm.item.sale_channel_id === channel.id) {
              vm.saleChannel = channel;
            }
          }

          // Sale sources
          if (channel.is_source) {
            vm.saleSources.push(channel);

            if (vm.createMode && !vm.bookingData && channel.is_default_source) {
              // Select default sale source
              vm.item.sale_source_id = channel.id;
            } else if (vm.item.sale_source_id === channel.id) {
              vm.saleSource = channel;
            }
          }
        }
      });
    }

    function getCurrencies(companyCurrencyIds) {
      if (vm.currenciesPerCompany) return;

      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
        time_zone_utc: vm.companyTimeZoneUtc,
        // documentDate: null,
      };

      if (!vm.createMode) {
        params.documentDate = vm.documentDate;
      }

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        if (vm.editMode) {
          vm.selectCurrency(vm.item.currency, true);
        }

        if (vm.bookingData) {
          let currency = vm.currenciesPerCompany.find((x) => x.id === vm.item.currency_id);
          vm.selectCurrency(currency, true);
        }

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function resetClientInput() {
      vm.item.client_id = null;
      vm.item.currency_id = null;
      vm.item.sale_condition_code = null;
      vm.item.credit_payment_days = null;
      vm.item.due_date = null;

      if (vm.saleCondition) {
        vm.saleCondition = null;
      }

      // if (vm.item.payment_method_code){
      //     vm.item.payment_method_code = null;
      // }

      if (vm.receivedPayment && vm.receivedPayment.payment_method_code) {
        vm.receivedPayment.payment_method_code = null;
        vm.receivedPayment.payment_method_id = null;
      }

      vm.item.bookings = [];
      vm.item.invoice_products = [];
      vm.addInvoiceProduct();
    }

    function getDocumentDateExchangeRate(currencyId) {
      if (vm.item.client_id === undefined) return;

      return ExchangeRateService.getDocumentDateExchangeRate(
        vm.currenciesPerCompany,
        vm.companyBaseCurrencyId,
        currencyId
      ); // , vm.documentDate
    }

    function resetProductFilter(invoiceProduct) {
      invoiceProduct.product_id = null;
      invoiceProduct.measurement_unit_id = null;
      invoiceProduct.quantity = 1;
      invoiceProduct.unit_price = ''; // 0
      invoiceProduct.discount_percentage = 0;

      invoiceProduct.tax_percentage = 0;
      invoiceProduct.tax_amount = 0;
      invoiceProduct.tax_exoneration_percentage = 0;
      invoiceProduct.tax_exoneration_amount = 0;
      invoiceProduct.net_tax_percentage = 0;
      invoiceProduct.net_tax_amount = 0;
      invoiceProduct.total_price = 0;

      vm.calculateInvoiceProductTotalPrice(invoiceProduct);
    }

    function getTaxesPerProduct(invoiceProduct, product) {
      product = vm.editMode ? invoiceProduct.product : product;

      let documentDate = moment(vm.item.date);

      invoiceProduct.productTaxes = TaxService.setProductTaxes(product, documentDate).saleTaxes;

      invoiceProduct.is_exempt = false;
      if (invoiceProduct.productTaxes.length === 0) {
        invoiceProduct.is_exempt = true;
      }

      // console.log(invoiceProduct.productTaxes);

      // let productTaxes = TaxService.setProductTaxes(product, documentDate).saleTaxes;
      // invoiceProduct.transaction_taxes = productTaxes;
    }

    function calculateInvoiceTotals() {
      let subtotal_services_taxable = 0;
      let subtotal_services_exempt = 0;
      let subtotal_services_exonerable = 0;
      let subtotal_goods_taxable = 0;
      let subtotal_goods_exempt = 0;
      let subtotal_goods_exonerable = 0;

      let total_sale = 0;
      let total_discount = 0;
      let total_net_sale = 0;
      let total_taxes = 0;
      let total_tax_exonerations = 0;
      let total_net_taxes = 0;
      let grand_total = 0;

      vm.allProductsCabysCodeSet = true;

      vm.item.invoice_products.forEach(function (invoice_product) {
        let total_amount = invoice_product.total_amount;

        // if (invoice_product.tax_amount > 0) {
        if (!invoice_product.is_exempt) {
          if (invoice_product.measurement_unit && invoice_product.measurement_unit.is_a_service) {
            if (invoice_product.tax_exoneration_amount > 0) {
              // subtotal_services_exonerable += (invoice_product.tax_exoneration_percentage / invoice_product.tax_percentage) * total_amount;
              // subtotal_services_taxable    += total_amount - subtotal_services_exonerable;
              // subtotal_services_taxable    += total_amount - invoice_product.tax_exoneration_amount;
              // subtotal_services_exonerable += invoice_product.tax_exoneration_amount;

              // Total gravado: (1-(Tarifa Exonerada IVA * 100%) / Tarifa IVA) * Monto total línea
              subtotal_services_taxable +=
                (1 -
                  (invoice_product.tax_exoneration_percentage * 1) /
                    invoice_product.tax_percentage) *
                total_amount;
              subtotal_services_exonerable += total_amount - subtotal_services_taxable;
              // Total gravado: (1-(5*1)/13) * 5000
              // Total gravado: 3076,92
            } else {
              subtotal_services_taxable += total_amount;
            }
          } else {
            if (invoice_product.tax_exoneration_amount > 0) {
              // subtotal_goods_exonerable += (invoice_product.tax_exoneration_percentage / invoice_product.tax_percentage) * total_amount;
              // subtotal_goods_taxable    += total_amount - subtotal_goods_exonerable;
              // subtotal_goods_taxable    += total_amount - invoice_product.tax_exoneration_amount;
              // subtotal_goods_exonerable += invoice_product.tax_exoneration_amount;

              // Total gravado: (1-(Tarifa Exonerada IVA * 100%) / Tarifa IVA) * Monto total línea
              subtotal_goods_taxable +=
                (1 -
                  (invoice_product.tax_exoneration_percentage * 1) /
                    invoice_product.tax_percentage) *
                total_amount;
              subtotal_goods_exonerable += total_amount - subtotal_goods_taxable;
            } else {
              subtotal_goods_taxable += total_amount;
            }
          }
        } else {
          if (invoice_product.measurement_unit && invoice_product.measurement_unit.is_a_service) {
            subtotal_services_exempt += total_amount;
          } else {
            subtotal_goods_exempt += total_amount;
          }
        }

        total_sale += invoice_product.total_amount;
        total_discount += invoice_product.discount_amount;
        total_net_sale += invoice_product.subtotal_price; // total_amount - discount_amount
        total_taxes += invoice_product.tax_amount;
        total_tax_exonerations += invoice_product.tax_exoneration_amount;
        total_net_taxes += invoice_product.net_tax_amount;
        grand_total += invoice_product.total_price;

        if (vm.atvCrEnabled && vm.isElectronicDocument && !invoice_product.product_cabys_code) {
          vm.allProductsCabysCodeSet = false;
        }
      });

      let total_taxable = subtotal_services_taxable + subtotal_goods_taxable;
      let total_exempt = subtotal_services_exempt + subtotal_goods_exempt;
      let total_exonerable = subtotal_services_exonerable + subtotal_goods_exonerable;
      let total_retornable_taxes = 0;
      let total_other_charges = 0;

      vm.item.subtotal_services_taxable = vm.UtilService.roundNum(subtotal_services_taxable);
      vm.item.subtotal_services_exempt = vm.UtilService.roundNum(subtotal_services_exempt);
      vm.item.subtotal_services_exonerable = vm.UtilService.roundNum(subtotal_services_exonerable);
      vm.item.subtotal_goods_taxable = vm.UtilService.roundNum(subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = vm.UtilService.roundNum(subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = vm.UtilService.roundNum(subtotal_goods_exonerable);

      vm.item.total_taxable = vm.UtilService.roundNum(total_taxable);
      vm.item.total_exempt = vm.UtilService.roundNum(total_exempt);
      vm.item.total_exonerable = vm.UtilService.roundNum(total_exonerable);
      vm.item.total_sale = vm.UtilService.roundNum(total_sale);
      vm.item.total_discount = vm.UtilService.roundNum(total_discount);
      vm.item.total_net_sale = vm.UtilService.roundNum(total_net_sale);

      vm.item.total_taxes = vm.UtilService.roundNum(total_taxes);
      vm.item.total_tax_exonerations = vm.UtilService.roundNum(total_tax_exonerations);
      vm.item.total_net_taxes = vm.UtilService.roundNum(total_net_taxes);
      vm.item.total_retornable_taxes = vm.UtilService.roundNum(total_retornable_taxes);
      vm.item.total_other_charges = vm.UtilService.roundNum(total_other_charges);
      vm.item.grand_total = vm.UtilService.roundNum(grand_total);

      // console.log(vm.item);

      // if (vm.saleCondition && vm.saleCondition.value === 'credit') { // TODO check as task TTA-689
      vm.item.balance_due = vm.item.grand_total;
      // }

      // if (invoice_product.measurement_unit) {}
    }

    // Check if needed - sometimes we just can change the currency
    // What about if the booking is in $ and we want to invoice in colons ??
    function convertInvoiceProductsPrices(currency, lastCurrencyId) {
      let applyExchangeRateConversion = (amount) =>
        ExchangeRateService.applyExchangeRateConversion(
          amount,
          vm.documentDateExchangeRateForConversions
        );

      // For conversions
      vm.documentDateExchangeRateForConversions =
        ExchangeRateService.getDocumentDateExchangeRateForConversions(
          vm.currenciesPerCompany,
          vm.companyBaseCurrencyId,
          currency.id,
          lastCurrencyId
        ); // , vm.documentDate

      vm.item.subtotal_services_taxable = applyExchangeRateConversion(
        vm.item.subtotal_services_taxable
      );
      vm.item.subtotal_services_exempt = applyExchangeRateConversion(
        vm.item.subtotal_services_exempt
      );
      vm.item.subtotal_services_exonerable = applyExchangeRateConversion(
        vm.item.subtotal_services_exonerable
      );
      vm.item.subtotal_goods_taxable = applyExchangeRateConversion(vm.item.subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = applyExchangeRateConversion(vm.item.subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = applyExchangeRateConversion(
        vm.item.subtotal_goods_exonerable
      );

      vm.item.total_taxable = applyExchangeRateConversion(vm.item.total_taxable);
      vm.item.total_exempt = applyExchangeRateConversion(vm.item.total_exempt);
      vm.item.total_exonerable = applyExchangeRateConversion(vm.item.total_exonerable);
      vm.item.total_sale = applyExchangeRateConversion(vm.item.total_sale);
      vm.item.total_discount = applyExchangeRateConversion(vm.item.total_discount);
      vm.item.total_net_sale = applyExchangeRateConversion(vm.item.total_net_sale);

      vm.item.total_taxes = applyExchangeRateConversion(vm.item.total_taxes);
      vm.item.total_tax_exonerations = applyExchangeRateConversion(vm.item.total_tax_exonerations);
      vm.item.total_net_taxes = applyExchangeRateConversion(vm.item.total_net_taxes);
      vm.item.total_retornable_taxes = applyExchangeRateConversion(vm.item.total_retornable_taxes);
      vm.item.total_other_charges = applyExchangeRateConversion(vm.item.total_other_charges);
      vm.item.grand_total = applyExchangeRateConversion(vm.item.grand_total);
      vm.item.balance_due = applyExchangeRateConversion(vm.item.balance_due);

      if (vm.item.invoice_products.length > 0) {
        vm.item.invoice_products.forEach(function (invoiceItem) {
          if (invoiceItem.unit_price) {
            invoiceItem.unit_price = applyExchangeRateConversion(invoiceItem.unit_price);
            invoiceItem.total_amount = applyExchangeRateConversion(invoiceItem.total_amount);
            invoiceItem.discount_amount = applyExchangeRateConversion(invoiceItem.discount_amount);
            invoiceItem.subtotal_price = applyExchangeRateConversion(invoiceItem.subtotal_price);

            invoiceItem.tax_amount = applyExchangeRateConversion(invoiceItem.tax_amount);
            invoiceItem.tax_exoneration_amount = applyExchangeRateConversion(
              invoiceItem.tax_exoneration_amount
            );
            invoiceItem.net_tax_amount = applyExchangeRateConversion(invoiceItem.net_tax_amount);
            invoiceItem.total_price = applyExchangeRateConversion(invoiceItem.total_price);
          }
        });
      }

      // not needed as it was get in selectCurrency
      // vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency); // currency.id
      // vm.lastCurrencyId = currency.id;
      // vm.lastCurrency   = currency;
      // console.log(vm.documentDateExchangeRate);

      // vm.item.total_voucher = applyExchangeRateConversion(vm.item.total_voucher);
      // invoiceItem.taxable_base = applyExchangeRateConversion(invoiceItem.taxable_base);
    }

    // Create / Update
    function saveInvoiceContinue(status) {
      const createInvoice = function () {
        /*if (vm.item.payment_method_code) {
                    vm.item.payment_method_codes.push(vm.item.payment_method_code);
                }*/

        if (vm.receivedPayment && vm.receivedPayment.payment_method_code) {
          vm.item.payment_method_code = vm.receivedPayment.payment_method_code;
          vm.item.payment_method_id = vm.receivedPayment.payment_method_id;
          vm.item.payment_method_codes = [vm.item.payment_method_code];
        } else {
          vm.item.payment_method_code = null;
          vm.item.payment_method_id = null;
          vm.item.payment_method_codes = [];
        }

        vm.item.status = setInvoiceStatus(vm.item, status);

        let invoice = setInvoiceParams();

        // console.log(invoice);
        // console.log(vm.receivedPayment);
        // return;

        vm.sendingForm = true;
        InvoiceService.saveInvoice(invoice, vm.receivedPayment).then((data) => {
          let status = data.status;
          let response = data.response;

          if (status) {
            // success
            if (!vm.editMode) {
              // create
              vm.onInvoiceSaved({ item: response });
            } else {
              vm.item = response; // reload item
              setItemOptions(response);

              setCompanyActivityCode(vm.company);

              setCompanySaleChannelsAndSaleSources(vm.company.sale_channels);

              vm.saleCondition = vm.company.sale_conditions.find(
                (x) => x.code === response.sale_condition_code
              );

              // if (response.payment_method_code) {
              // vm.paymentMethod = vm.company.payment_methods.find((x) => x.code === response.payment_method_code);
              // }

              // if (response.payment_method_code) {
              // vm.receivedPayment.payment_method_code = vm.company.payment_methods.find((x) => x.code === response.payment_method_code);
              // }

              vm.user = vm.company.users.find((x) => x.id === response.user_id);

              if (response.credit_payment_days >= 0) {
                vm.creditPaymentTerm = vm.company.credit_payment_terms.find(
                  (x) => x.days === response.credit_payment_days
                );
              }

              setInvoiceProducts();
            }
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        });
      };

      if (status !== vm.statusDraft && vm.sendInvoiceToClient) {
        const successCallBack = function (email) {
          vm.item.client_email_receipt = email;

          createInvoice();
        };

        InvoiceService.openSendInvoiceToClient(vm.item.client.email, successCallBack);
      } else {
        if (vm.item.client) {
          vm.item.client_email_receipt = vm.item.client.email;
        }

        createInvoice();
      }
    }

    function setInvoiceStatus(invoice, status) {
      if (status === vm.statusDraft) return status;

      if (vm.saleCondition.value === 'credit') {
        if (moment() >= invoice.due_date) {
          return 'overdue';
        } else {
          return 'open';
        }
      }

      return status;
    }

    // Remove unnecessary params
    function setInvoiceParams() {
      let invoice = angular.copy(vm.item);

      delete invoice.currency;
      delete invoice.client;
      delete invoice.bookings;

      invoice.invoice_products.forEach(function (product) {
        delete product.$$hashKey;
        delete product.measurement_units;
        delete product.measurement_unit;
        delete product.product;
        delete product.bookingItemUnitPrice;
        delete product.bookingItemTotalPrice;

        if (!product.unit_price) {
          product.unit_price = 0;
        }
      });

      return invoice;
    }

    // Set related data to each product
    function setInvoiceProducts() {
      vm.loadingInvoiceProducts = false;

      if (vm.item.invoice_products.length === 0) return;

      vm.allProductsCabysCodeSet = true;

      vm.item.invoice_products.forEach(function (invoice_product) {
        invoice_product.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          invoice_product.product_type
        );

        let measurementUnit = invoice_product.measurement_units.find(
          (item) => item.id === invoice_product.measurement_unit_id
        );

        vm.selectMeasurementUnit(invoice_product, measurementUnit);

        // If product is related to booking item
        if (invoice_product.booking_item_id) {
          invoice_product.bookingItemUnitPrice = invoice_product.unit_price;
          invoice_product.bookingItemTotalPrice = invoice_product.total_price;
        }

        // For the search product input
        invoice_product.product = {
          id: invoice_product.product_id,
          code: invoice_product.product_code,
          cabys_code: invoice_product.product_cabys_code,
          name: invoice_product.product_name,
          type: invoice_product.product_type,
        };

        if (vm.atvCrEnabled && vm.isElectronicDocument && !invoice_product.product_cabys_code) {
          vm.allProductsCabysCodeSet = false;
        }
      });
    }

    function bookingsInUsed() {
      if (vm.item.bookings) {
        for (let i = 0; i < vm.item.bookings.length; i++) {
          let booking = vm.item.bookings[i];

          if (booking.bookingInUsed > 0) {
            return true;
          }
        }
      }

      return false;
    }

    function createInvoiceProductsFromBookingItem(bookingItem, booking) {
      let params = {
        id: bookingItem.detail.id, // bookingItem.product_id
        type: bookingItem.booking_type, // bookingItem.detail.type
        skip_check_role: true,
      };

      ProductService.searchProducts(params).then((product) => {
        // data
        // for (let i = 0; i < data.length; i++) {
        // let product = data[i];
        // if (product.id === bookingItem.detail.id) {

        let discount_percentage = 0; // TODO: Check implementation
        if (booking.discount_coupon) {
          if (booking.discount_coupon.discount_type === 'percentage') {
            discount_percentage = booking.discount_coupon.value / 100;
          } else {
            discount_percentage = booking.discount_coupon.value;
          }
        }

        let invoiceProduct = {
          product_id: bookingItem.detail.id,
          product_code: bookingItem.detail.code,
          product_cabys_code: bookingItem.detail.cabys_code,
          product_type: bookingItem.booking_type,
          product_name: bookingItem.detail.name,

          quantity: bookingItem.quantity,
          subtotal_price: 0,
          tax_percentage: 0,
          tax_amount: 0,
          discount_percentage: discount_percentage,
          discount_amount: 0,

          total_amount: 0,
          total_price: 0,

          measurement_unit_id: bookingItem.measurement_unit_id,
          invoice_products_ids: bookingItem.invoice_products_ids,

          booking_number: booking.booking_number,
          booking_item_id: bookingItem.id,

          product: bookingItem.detail,

          bookingItemUnitPrice: 0,
          bookingItemTotalPrice: 0,
          unit_price: 0,
          measurement_units: [],
        };

        getTaxesPerProduct(invoiceProduct, product);

        invoiceProduct.bookingItemUnitPrice = bookingItem.subtotal_price / invoiceProduct.quantity; // invoiceProduct.price

        let unitPrice =
          invoiceProduct.bookingItemUnitPrice -
          invoiceProduct.discount_percentage +
          invoiceProduct.tax_amount;

        invoiceProduct.bookingItemTotalPrice = invoiceProduct.quantity * unitPrice;

        invoiceProduct.unit_price = vm.UtilService.roundNum(invoiceProduct.bookingItemUnitPrice);
        invoiceProduct.total_price = vm.UtilService.roundNum(invoiceProduct.bookingItemTotalPrice);

        invoiceProduct.measurement_units = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          invoiceProduct.product_type
        );

        let measurementUnit = invoiceProduct.measurement_units.find(
          (item) => item.id === invoiceProduct.measurement_unit_id
        );

        vm.selectMeasurementUnit(invoiceProduct, measurementUnit);

        if (vm.item.invoice_products.length === 1 && !vm.item.invoice_products[0].product_name) {
          vm.item.invoice_products.splice(0, 1);
        }

        vm.item.invoice_products.push(invoiceProduct);

        vm.calculateInvoiceProductTotalPrice(invoiceProduct);

        // break;
        // }
        // }
      });
    }

    function setPaymentDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        vm.documentDate = moment(vm.item.date);
        // getDocumentDateExchangeRate(vm.item.currency); // vm.item.currency_id // what for ????

        if (vm.item.due_date) {
          vm.selectCreditPaymentTerm(vm.item.credit_payment_days);
        }
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }

    function hideWarningMessageModal(data) {
      if (data) SessionService.hideWarningMessage('receivedPayments', data);
    }

    // Client does not have a state, us client for atv companies
    function validateClientForDocumentType() {
      // 01 = Individual
      if (
        vm.atvCrEnabled &&
        vm.documentType.type == '01' &&
        (!vm.item.client.tax_id_number || !vm.item.client.state)
      ) {
        // if (vm.atvCrEnabled && vm.documentType.type == '01' && (!vm.item.client.state || !vm.item.client.city || !vm.item.client.district)) {
        // electronic invoice
        vm.invalidClientForDocumentType = true;
      } else {
        vm.invalidClientForDocumentType = false;
      }
    }

    function transformNotes(bookingData) {
      let fullName = '';
      if (bookingData.bookings[0].guests.length > 0) {
        const { name, last_name } = bookingData.bookings[0].guests.find(
          (guest) => guest.is_default
        );

        fullName = `| ${name} ${last_name}`;
      }

      const notes = bookingData.notes ? `${bookingData.notes} |` : '';
      const bookingNumber = bookingData.bookings[0].booking_number;

      return `${notes} ${bookingNumber} ${fullName}`;
    }
  }
})();
